import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";

interface LoadingButtonProps extends Omit<ButtonProps, "children"> {
  isLoading?: boolean;
  text?: React.ReactNode;
}

const LoadingButton = ({
  isLoading = false,
  disabled = false,
  text = "",
  onClick,
  className = "",
  type = "button",
  ...rest
}: LoadingButtonProps) => {
  return (
    <>
      <Button
        className={`${className}`}
        disabled={isLoading || disabled}
        onClick={
          !isLoading ? onClick : (null as unknown as ButtonProps["onClick"])
        }
        type={type}
        variant="contained"
        color="primary"
        size="large"
        {...rest}
      >
        {isLoading ? (
          <CircularProgress
            size={24}
            aria-label="Loading"
            sx={{
              // Loading text follows the containing primary control.
              color: "var(--palette-primary-contrastText) !important",
              "& .MuiCircularProgress-circle": {
                stroke: "var(--palette-primary-contrastText) !important",
              },
            }}
          />
        ) : (
          <span>{text}</span>
        )}
      </Button>
    </>
  );
};

export default LoadingButton;
